var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',_vm._g(_vm._b({class:{ logo: true },attrs:{"alt":"logo","src":require("@/assets/image/uptick network_logo.svg"),"height":_vm.height}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }